export default class Person {
    public person_id: number | null = null;
    public gueltig: string | null = 'j';
    public arzt: string | null = null;
    public nachname: string | null = null;
    public vorname: string | null = null;
    public titel: string | null = null;
    public rolle: string | null = null;
    public impfstelle_id: number | null = null;
    public personalzahl: number | null = null;
    public arztnr: string | null = null;
    public signatur: string | null = null;

    constructor(data?: Partial<Person>) {
        Object.assign(this, data);
    }
}
